<script lang="ts">
  const isLoadedFromApp =
    new URLSearchParams(window.location.search).get("app") === "true";
</script>

{#if !isLoadedFromApp}
  <slot></slot>
{/if}
